import { Button, Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useReactHookForm } from '../../../../hooks/useReactHookForm';
import { ReactHookForm } from '../../../../components/hook-form/react-hook-form.component';
import FormInput from '../../../../components/hook-form/form-input.component';
import { FormCheckbox } from '../../../../components/hook-form/form-checkbox.component';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface ColumnOptionsModalProps {
  isVisible: boolean;
  onModalClose: () => void;
  // entityFields: EntityField[];
  onSubmit: (data: any) => void;
  // selectedEntityFields: Record<number, EntityField>;
}

const SaveQueryModal = ({ isVisible, onModalClose, onSubmit }: ColumnOptionsModalProps) => {
  const form = useReactHookForm({
    defaultValues: {},
  });

  const handleSubmit = (data: any) => {
    onSubmit(data);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <div>
      {' '}
      <Dialog
        open={isVisible}
        fullWidth={true}
        maxWidth={'md'}
        // onClose={onCloseClick}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"> Save Query</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onModalClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Tooltip title={<Typography variant="body1">Close</Typography>}>
            <CloseIcon />
          </Tooltip>
        </IconButton>
        <DialogContent dividers className="popupDilog">
          {' '}
          <ReactHookForm formName="QUERY_BUILDER_SAVE_FORM" onSubmit={handleSubmit} formContextProps={form}>
            {' '}
            <FormInput name="reportName" label="Report name" />
            <FormCheckbox label="Make Global" name="isGlobal" />
            <Button type="submit" style={{ marginLeft: 3 }} variant="contained" disabled={isReadOnlyPermission}>
              Submit
            </Button>
          </ReactHookForm>{' '}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default SaveQueryModal;
